<form novalidate #propertyPromoteSectionForm="ngForm">
  <div class="property_promote_section" *ngIf="draftLoaded$ | async">
    <tg-row>
      <tg-col sm="12">
        <h1 class="property-promote-section__title">
          Choose your listing type
        </h1>
        <p class="property-promote-section__lead-copy" [innerHtml]="pageSubTitle"></p>
      </tg-col>
    </tg-row>
    <tg-row *ngIf="showFeesInformation">
      <tg-col md="6" sm="12">
        <div class="property-promote-section__feesInformationDiv">
          <label class="property-promote-section__feesInformationDiv__title">You have not provided a Capital value for
            your listing</label>
          <label class="property-promote-section__feesInformationDiv__text">
            Your listing fee is based on ‘No CV’, for more information see our fees page. If applicable, you can enter
            the CV on the Property information page.
          </label>
          <div class="property-promote-section__feesInformationDiv__link">
            <a href="https://help.trademe.co.nz/hc/en-us/articles/360032007872-Property-fees#h_ad3eee9a-0cb8-4114-a9f8-58a6c5d7289a"
              target="_blank" class="h-link-no-visited">See our fees page for more details</a>
          </div>
          <div class="property-promote-section__feesInformationDiv__link">
            <a routerLink="../{{ stepIds.propertyInformation }}" routerLinkActive="active" class="h-link-no-visited">Go
              back to Property information</a>
          </div>
        </div>
      </tg-col>
    </tg-row>
    <tg-row class="property-promote-section__margin-bottom">
      <tg-col md="6" sm="12">
        <tg-info-box tgStyle="danger" *ngIf="displayError && !isMobile">
          <tg-icon name="camera" alt="information">
          </tg-icon>
          <tg-info-box-heading>
            You need to add at least
            {{ selectedBundle.minPhotoRequired }} photo(s) to select
            a {{ selectedBundle.name }} listing.
          </tg-info-box-heading>
          Select a different listing type or add more photos.
          <tg-info-box-actions>
            <button tgButton2 transparent routerLink="../{{ stepIds.propertyPhotos }}">
              Add more photos
            </button>
          </tg-info-box-actions>
        </tg-info-box>
        <div *ngFor="let fee of fees" (click)="setPhotos(fee.id); publish();handleChangeCategoryPackageId();" [ngClass]="{
                        'property-promote-section__disabled':
                            fee.isDisabled
                    }">
          <tg-info-box tgStyle="danger" *ngIf="displayError &&
                            isMobile &&
                            fee.id === selectedBundle.id">
            <tg-icon name="camera" alt="information">
            </tg-icon>
            <tg-info-box-heading>
              You need to add at least
              {{ selectedBundle.minPhotoRequired }} photo(s) to
              select a {{ selectedBundle.name }} listing.
            </tg-info-box-heading>
            Select a different listing type or add more photos.
            <tg-info-box-actions>
              <button tgButton2 transparent routerLink="../{{ stepIds.propertyPhotos }}">
                Add more photos
              </button>
            </tg-info-box-actions>
          </tg-info-box>
          <tg-card bordered class="property-promote-section__card"
            [ngClass]="{selectedCard: fee.id === selectedBundle.id}">
            <tg-row>
              <tg-col md="7" sm="6">
                <label class="container">
                  {{ fee.name }}
                  <input type="radio" [id]="fee.name" name="categoryPackageId" [value]="fee.id" [(ngModel)]="draftData.propertyPromote
                                                .categoryPackageId"
                    [validation]="validation.propertyPromote.categoryPackageId | toValidator">
                  <span [ngClass]="{
                        'disable': fee.isDisabled
                    }" class="checkmark"></span>
                </label>
              </tg-col>
              <tg-col md="5" sm="6">
                <div *ngIf="fee.packagePrice" class="property-promote-section__priceDisplay" [innerHTML]="fee.packagePrice
                                            | tgCurrency
                                            | tmSupCurrency"></div>
                <div *ngIf="fee.packagePrice === 0" class="property-promote-section__yourPromotion">
                  {{zeroChargeMessage}}</div>
              </tg-col>
            </tg-row>
            <tg-row>
              <tg-col sm="12" class="property-promote-section__subTitle">
                <span [innerHTML]="fee.description"></span>
              </tg-col>
            </tg-row>
            <tg-row class="property-promote-section__bottomMargin">
              <tg-col sm="12">
                <ul tgList2 compact type="icon">
                  <li *ngFor="let detail of fee.details" [ngClass]="{ disabled: !detail.checked}">
                    {{ detail.description }}
                    <tg-icon-left *ngIf="detail.checked" name="basic-tick" alt="tick" size="small">
                    </tg-icon-left>
                    <tg-icon-left *ngIf="!detail.checked" name="basic-cross" alt="tick" size="small">
                    </tg-icon-left>
                  </li>
                </ul>
              </tg-col>
            </tg-row>
          </tg-card>
          <tg-row>
            <tg-col sm="12" class="property-promote-section__viewMore">
              <button tgButton2 fullWidth (click)="openModal(fee.photos, fee.name)">
                <tg-icon-left name="eye" alt="eye">
                </tg-icon-left>
                View Example
              </button>
            </tg-col>
          </tg-row>
        </div>
      </tg-col>
      <tg-col md="6" class="property-promote-section__image-column">
        <tg-row class="property-promote-section__images" *ngFor="let photo of distinctPhotos">
          <tg-col md="12">
            <label *ngIf="photo.selected" class="p-secondary-copy">
              {{ photo.description }}
            </label>
            <img [ngClass]="{ blurred: !photo.selected }" src="./assets/images/{{ photo.url }}">
          </tg-col>
        </tg-row>
      </tg-col>
    </tg-row>
    <tg-row class="property-promote-section__superfeature" *ngIf="isAllowDisplayReviewPromotionSection">
      <tg-col md="6" sm="12">
        <label class="property-promote-section__review-promotion-title">Renew promotion</label>
        <p>You can renew your expired promotional feature.</p>
        <tg-card bordered class="property-promote-section__card">
          <tg-row>
            <tg-col md="8" sm="6">
              <tg-checkbox name="hasSuperFeature" (change)="publish()"
                [(ngModel)]="draftData.propertyPromote.hasSuperFeature">
                <tg-label class="checkbox-label d-block">
                  Carousel
                </tg-label>
                <tg-label>
                  Super Feature<sup>3</sup>
                </tg-label>
              </tg-checkbox>
            </tg-col>
            <tg-col md="4" sm="6">
              <div class="property-promote-section__priceDisplay"
                [innerHTML]="superFeatureFee | tgCurrency | tmSupCurrency"></div>
            </tg-col>
          </tg-row>
          <tg-row>
            <tg-col sm="12" class="property-promote-section__subTitle">
              <span>Appear in <b>carousel at top of search results</b> for 7 days</span>
            </tg-col>
          </tg-row>
        </tg-card>
      </tg-col>
    </tg-row>
    <tg-row>
      <tg-col sm="12" md="6">
        <small [innerHtml]="pageFooterNotes"></small>
      </tg-col>
    </tg-row>
    <tg-modal *ngIf="showModal" (close)="showModal = false" fullscreen>
      <tg-modal-header>
        <h2>View Example</h2>
        <h3>{{ packageName }}</h3>
      </tg-modal-header>
      <tg-modal-body>
        <tg-row *ngFor="let photo of modalPhotos" class="property-promote-section__row-mobile-spacing">
          <tg-col md="12">
            <label class="p-secondary-copy">{{ photo.description }}</label>
            <img src="./assets/images/{{ photo.url }}">
          </tg-col>
        </tg-row>
      </tg-modal-body>
      <tg-modal-footer></tg-modal-footer>
    </tg-modal>
  </div>
</form>
